import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { CPL3Settings, ICPLCPL3SettingsClient } from "./api/cplapi/CPLAPI";

export interface ICPLSettingsService {
  getBooleanSetting(settingType: CPL3Settings): Promise<boolean>;
  updateBooleanSetting(settingType: CPL3Settings, value: boolean): Promise<void>;
  getStringSetting(settingType: CPL3Settings): Promise<string>;
  updateStringSetting(settingType: CPL3Settings, value: string | undefined): Promise<void>;
  getIntSetting(settingType: CPL3Settings): Promise<number | undefined>;
  updateIntSetting(settingType: CPL3Settings, value: number | undefined): Promise<void>;
}

@injectable()
export class CPLSettingsService implements ICPLSettingsService {
  @inject(SERVICE_TYPES.CPLCPL3SettingsClient) cplSettingsClient!: ICPLCPL3SettingsClient;

  async getBooleanSetting(settingType: CPL3Settings): Promise<boolean> {
    return this.cplSettingsClient.getBooleanSetting(settingType);
  }

  async updateBooleanSetting(settingType: CPL3Settings, value: boolean): Promise<void> {
    return this.cplSettingsClient.updateBooleanSetting(settingType, value);
  }

  async getStringSetting(settingType: CPL3Settings): Promise<string> {
    return this.cplSettingsClient.getStringSetting(settingType);
  }

  async updateStringSetting(settingType: CPL3Settings, value: string | undefined): Promise<void> {
    return this.cplSettingsClient.updateStringSetting(settingType, value);
  }

  async getIntSetting(settingType: CPL3Settings): Promise<number | undefined> {
    return this.cplSettingsClient.getIntSetting(settingType);
  }

  async updateIntSetting(settingType: CPL3Settings, value: number | undefined): Promise<void> {
    return this.cplSettingsClient.updateIntSetting(settingType, value);
  }
}
